// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2mFlV","error":"Textarea_error__3Y9cS","readonly":"Textarea_readonly__20EI0","disabled":"Textarea_disabled__28jT4"};